var scope_0 = require('/home/chip/code/gpt2/static-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/892e560076192f2a4eb6735c751fc317.js').default;export default
        Object.assign({}, scope_0 )
    